import { render } from "./PaintCollection.vue?vue&type=template&id=4540910f&scoped=true&lang=html"
import script from "./PaintCollection.vue?vue&type=script&lang=js"
export * from "./PaintCollection.vue?vue&type=script&lang=js"

import "./PaintCollection.vue?vue&type=style&index=0&id=4540910f&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4540910f"]])

export default __exports__